import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function Level15Illustration({
  achievementId,
  variant = 'cosmic',
  // Unlocks cosmic variant
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3918" data-mp="1thd3jr0af966">
      <div className="relative w-full h-full bg-gradient-to-br from-slate-900 via-indigo-950 to-purple-950 overflow-hidden" data-id="element-3919" data-mp="1yh993uomv8nu">
        {/* Background: Space, Nebula, Planets */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3920" data-mp="2791ehqysvrlk">
          {/* Nebula clouds */}
          <circle cx="40" cy="40" r="60" fill="#8B5CF6" opacity="0.2" filter="blur(15px)" data-id="element-3921" data-mp="1erf8qs7url80" />
          <circle cx="160" cy="160" r="70" fill="#3B82F6" opacity="0.2" filter="blur(20px)" data-id="element-3922" data-mp="3hmkaj04wz9hp" />
          <circle cx="150" cy="50" r="50" fill="#EC4899" opacity="0.15" filter="blur(15px)" data-id="element-3923" data-mp="3ctr1i02exezt" />

          {/* Planet */}
          <circle cx="160" cy="40" r="20" fill="#FDE047" opacity="0.8" data-id="element-3924" data-mp="32vjqdxut1r5q" />
          <path d="M130 50 Q160 30 190 50" stroke="#FEF08A" strokeWidth="4" strokeLinecap="round" fill="none" transform="rotate(-15 160 40)" data-id="element-3925" data-mp="2yuhn95xrouyh" />

          {/* Distant stars */}
          <circle cx="30" cy="80" r="1" fill="white" data-id="element-3926" data-mp="s64pj7nyngt9" />
          <circle cx="80" cy="30" r="1.5" fill="white" data-id="element-3927" data-mp="s4ti8xvb3qxe" />
          <circle cx="120" cy="120" r="1" fill="white" data-id="element-3928" data-mp="n68kr67fvlcn" />
          <circle cx="50" cy="150" r="2" fill="white" data-id="element-3929" data-mp="n4p4hfls9aav" />
          <circle cx="180" cy="100" r="1.5" fill="white" data-id="element-3930" data-mp="2hlyjtraux3io" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[5%]" data-id="element-3931" data-mp="2mei7jh39df17">
          <div className="w-[65%] h-[65%] flex items-center justify-center animate-[bounce_4s_ease-in-out_infinite]" data-id="element-3932" data-mp="27pc2hchqoule">
            <DjaySpecimen look={{
            variant,
            accessory: 'cosmicOrb'
          }} size="hero" emotion={isUnlocked ? 'proud' : 'sleeping'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3933" data-mp="2cof8az5jn4uf" />
          </div>
        </div>

        {/* Foreground: Floating Asteroids and Magic */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3934" data-mp="2vg7yklt8abyg">
            {/* Asteroids */}
            <path d="M20 120 L25 115 L35 118 L30 125 Z" fill="#64748B" data-id="element-3935" data-mp="20tpewt04fpu" />
            <path d="M170 140 L180 135 L185 145 L175 150 Z" fill="#475569" data-id="element-3936" data-mp="3t7mtq9j3cuyl" />
            <path d="M40 40 L45 35 L50 42 L42 45 Z" fill="#94A3B8" data-id="element-3937" data-mp="3t9quiilp1dun" />

            {/* Sparkles */}
            <path d="M140 80 L142 85 L147 87 L142 89 L140 94 L138 89 L133 87 L138 85 Z" fill="#A78BFA" data-id="element-3938" data-mp="azxcebvahf9m" />
            <path d="M60 160 L61 163 L64 164 L61 165 L60 168 L59 165 L56 164 L59 163 Z" fill="#60A5FA" data-id="element-3939" data-mp="3ffq4cd8t4z5w" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}